<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-24 mobile-min-height"
    >
      <div class="d-flex-column flex-15 t-white" style="min-height: 48px">
        <div class="d-flex-column justify-start align-start gap-16">
          <LazyCustomSeasonLengthNew
            v-if="showSeasonLength"
            :season-length="getGame?.game_season"
          />
          <CodSelector :show-service="false" />
        </div>
      </div>

      <!-- PACkS HERE -->
      <div
        class="d-flex-column flex-65 justify-start align-start t-white gap-24"
      >
        <Bo6CamoBoost v-if="currentGamePackSlug === 'black-ops-6-camo-boost'" />
        <Bo6PrestigeBoost
          v-else-if="currentGamePackSlug === 'black-ops-6-prestige-boost'"
        />
        <Bo6WeaponLevelBoost
          v-else-if="
            currentGamePackSlug === 'black-ops-6-weapon-leveling-boost'
          "
        />
        <Bo6NukeBoost
          v-else-if="currentGamePackSlug === 'black-ops-6-nuke-boost'"
        />
        <Bo6ReticlesBoost
          v-else-if="currentGamePackSlug === 'black-ops-6-reticles-boost'"
        />
        <ZomCamoBoost
          v-else-if="currentGamePackSlug === 'black-ops-6-zombie-camo-boost'"
        />
        <ZomReticlesBoost
          v-else-if="
            currentGamePackSlug === 'black-ops-6-zombie-reticles-boost'
          "
        />
        <WzCamoBoost v-else-if="currentGamePackSlug === 'warzone-camo-boost'" />
        <div class="d-flex-column justify-start xl-hide" v-if="getPackFaq">
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}s
          </p>
          <Faq :faqs="getPackFaq" variant="pack" />
        </div>
      </div>

      <div
        class="d-flex-column flex-2 justify-start align-start t-white cart_container"
      >
        <WhyWeCheap />
        <Cart />
        <SafeSecurePayments />

        <div
          class="d-flex-column justify-start above-xl-hide"
          v-if="getPackFaq"
          style="margin-top: 24px"
        >
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}s
          </p>
          <Faq :faqs="getPackFaq" variant="pack" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import GamePackBanner from "~/components/banners/GamePackBanner.vue";
import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";
import SeasonLength from "~/components/custom/SeasonLength.vue";
import SafeSecurePayments from "~/components/calculators/checkout/SafeSecurePayments.vue";
import CodSelector from "~/components/sections/boosting/CodSelector.vue";
import Cart from "~/components/calculators/checkout/Cart.vue";
import Bo6CamoBoost from "~/components/calculators/call-of-duty/bo6/Bo6CamoBoost.vue";
import Bo6PrestigeBoost from "~/components/calculators/call-of-duty/bo6/Bo6PrestigeBoost.vue";
import ZomCamoBoost from "~/components/calculators/call-of-duty/zombies/ZomCamoBoost.vue";
import WzCamoBoost from "~/components/calculators/call-of-duty/warzone/WzCamoBoost.vue";
import Bo6WeaponLevelBoost from "~/components/calculators/call-of-duty/bo6/Bo6WeaponLevelBoost.vue";
import Bo6NukeBoost from "~/components/calculators/call-of-duty/bo6/Bo6NukeBoost.vue";
import Bo6ReticlesBoost from "~/components/calculators/call-of-duty/bo6/Bo6ReticlesBoost.vue";
import ZomReticlesBoost from "~/components/calculators/call-of-duty/zombies/ZomReticlesBoost.vue";
import Faq from "~/components/custom/Faq.vue";
const { currentGamePackSlug } = useGameComposable();

const { getGamePack, getGame } = useGameStore();

const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});
const getPackFaq = computed(() => {
  if (getGamePack?.faqs) {
    return getGamePack.faqs;
  }
  return null;
});
</script>
